import React from 'react';
import { PipelineDashboard } from './pages/PipelineDashboard';
export function App() {
  return <PipelineDashboard data-id="element-0" />;
}